import React from 'react'

import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import PopoverButton from 'components/common/PopoverButton'

function AddressOverridesCell({ row, colId, getDataDisplay }) {
  return <TableCell>{getDataDisplay(row, colId)}</TableCell>
}

function AddressOverridesRow({
  row,
  rowKey,
  visibleColumns = [],
  getDataDisplay,
  handleAction,
}) {
  return (
    <>
      <TableRow key={row[rowKey]}>
        {visibleColumns.map((col) => (
          <AddressOverridesCell
            key={`${row[rowKey]}-${col}`}
            row={row}
            getDataDisplay={getDataDisplay}
            colId={col}
          />
        ))}
        <TableCell>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <PopoverButton
              color="primary"
              variant="contained"
              sx={{ flex: 1 }}
              onClick={() => {
                handleAction(row, 'edit')
              }}
            >
              Edit
            </PopoverButton>
            <PopoverButton
              color="primary"
              variant="outlined"
              popover={true}
              popoverMessage={
                <>
                  Are you sure you want to delete this address override?
                  <br /> This action is irreversible.
                </>
              }
              popoverProps={{
                anchorOrigin: {
                  vertical: -100,
                  horizontal: -64,
                },
              }}
              acceptButtonProps={{
                children: 'Confirm',
              }}
              onClick={() => {
                handleAction(row, 'delete')
              }}
              sx={{ flex: 1 }}
            >
              Delete
            </PopoverButton>
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}

export default AddressOverridesRow
